// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"
import "./mulberrys/profile-image-preview";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import myaddress from './routes/account/myaddress';
import ePickup from './routes/epickup';
import login from './routes/login';
import myAccount from './routes/account/account';
import preferences from './routes/account/preferences';
import notifications from './routes/account/notifications';
import mypaymentinfo from './routes/account/creditcard';
import promocode from './routes/account/promo';
import referAFriend from './routes/inviteFriend';
import forgotpassword from './routes/forgotpassword';
import resetpassword from './routes/resetpassword';
import register from './routes/register';
import storeLocator from './routes/store-locator';
import schedulePickup from './routes/schedule-pickup';
import schedulePickupGuest from './routes/schedule-pickup-guest';
import getPriceQuote from './routes/price-quote';
import singleStore from './routes/single-store';
import templateSeoSingleStoreDc from './routes/single-store-dc';
import review from './routes/review';
import deliveryManifest from './routes/deliverymanifest';
import templateOrderDriverTracking from './routes/order-driver-tracking';
import templateZubieDriverTracking from './routes/zubie-driver-tracking';
import orders from './routes/orders';
import giftCard from './routes/gift-card';
import pricing from './routes/price-by-location';
import franchise from './routes/franchise';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  myaddress,
  ePickup,
  login,
  myAccount,
  mypaymentinfo,
  promocode,
  preferences,
  notifications,
  referAFriend,
  forgotpassword,
  resetpassword,
  register,
  storeLocator,
  schedulePickup,
  getPriceQuote,
  singleStore,
  templateSeoSingleStoreDc,
  review,
  deliveryManifest,
  schedulePickupGuest,
  templateOrderDriverTracking,
  templateZubieDriverTracking,
  orders,
  giftCard,
  pricing,
  franchise,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js